/* @jsxImportSource react */

import { type FC } from 'react';

import { ErrorBoundary } from '@packages/shared/src/components/ErrorBoundary/ErrorBoundary';

import { SlotsMinimal } from '../MetaNavigation/DesktopSlots/SlotsMinimal';
import { LinkedLogo } from '../Toolbar/LinkedLogo';
import { MinimalHeaderLayout } from './layout';
import { ResponsiveHeaderErrorFallback } from '../ResponsiveHeaderErrorFallback';

export const MinimalHeader: FC = () => (
  <MinimalHeaderLayout>
    <div className="mx-1 place-self-stretch [grid-area:logo] xl:mx-0">
      <ErrorBoundary fallback={<ResponsiveHeaderErrorFallback />}>
        <LinkedLogo />
      </ErrorBoundary>
    </div>
    <div className="relative flex overflow-hidden [grid-area:icons]">
      <ErrorBoundary fallback={<ResponsiveHeaderErrorFallback />}>
        <SlotsMinimal />
      </ErrorBoundary>
    </div>
  </MinimalHeaderLayout>
);
